import { render, staticRenderFns } from "./Others.vue?vue&type=template&id=52b8cc08&scoped=true&"
import script from "./Others.vue?vue&type=script&lang=js&"
export * from "./Others.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52b8cc08",
  null
  
)

export default component.exports